/**
 * APPLICATION IMPORTS
 */
// import 'zone.js'; // Included with Angular CLI.
// (window as any)['global'] = window;

/**
 * WEBAPP 
 */
// declare global {
//    interface Window {
//       localAudio?: any;
//       localStream?: any;
//       Gleap?: any;
//    }
// }

// My Array Methods
if (!Array.prototype.includesMultiple) {
   /**
     * Determines whether an array includes all search elements, returning true or false as appropriate.
     * @param searchElements The elements array to search for.
   */
   Array.prototype.includesMultiple = function <T>(searchElements: T[]): boolean {
      return searchElements.every(value => this.includes(value));
   };
}

if (!Array.prototype.includesSome) {
   /**
     * Determines whether an array includes some search elements, returning true or false as appropriate.
     * @param searchElements The elements array to search for.
   */
   Array.prototype.includesSome = function <T>(searchElements: T[]): boolean {
      return searchElements.some(value => this.includes(value));
   };
}